import React from 'react';
import { Box as ChakraBox, BoxProps as ChakraBoxProps } from '@chakra-ui/react';

export function Box(props: ChakraBoxProps) {
  return <ChakraBox {...props} />;
}
